import type { GraphQLError } from 'graphql';
import type { useHomeWidgetStateQuery$data } from './__generated__/useHomeWidgetStateQuery.graphql.ts';
import { preloadHomeWidgets } from './preloadHomeWidgets.ts';

export const preloadSidePanel = ({
	isLicensed,
}: {
	isLicensed: boolean;
}):
	| Promise<void>
	| Promise<{
			data: useHomeWidgetStateQuery$data | null;
			errors?: ReadonlyArray<GraphQLError>;
			hasErrors: boolean;
	  }> => {
	return preloadHomeWidgets({ isLicensed });
};
